module.exports = __webpack_public_path__ + "img/workflowSettings_02.67a5413d.png";